<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
  <path
    fill="none"
    stroke="currentColor"
    stroke-linecap="square"
    stroke-width="1.5"
    d="M1 2h3l3 11m0 0h12l3-9M7 13l-1 4h15M7 21a1 1 0 1 1-2 0a1 1 0 0 1 2 0Zm14 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0ZM13 3v3m0 0v3m0-3h3m-3 0h-3" />
</svg>
